import { ReactNode } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { FileSpreadsheet, ReceiptText, ScrollText } from "lucide-react";

import { Tabs, TabsList, TabsTrigger } from "../utils/components/ui/tabs";

type SalesProps = {
  children?: ReactNode;
};

function Sales({ children }: SalesProps) {
  const navigate = useNavigate();
  const location = useLocation();

  let tabValue = "draft";
  if (location.pathname.includes("/sales/quatation")) tabValue = "quotation";
  else if (location.pathname.includes("/sales/invoice")) tabValue = "invoice";
  else if (location.pathname.includes("/sales/draft")) tabValue = "draft";

  return (
    <div className="space-y-6">
      <section className="rounded-[28px] border border-[#E8EEF9] bg-white px-6 py-6 shadow-[0_16px_40px_rgba(26,94,249,0.08)]">
        <div className="flex flex-col gap-5 xl:flex-row xl:items-end xl:justify-between">
          <div>
            <h1 className="text-[34px] font-semibold tracking-[-0.03em] text-[#1A5EF9]">
              Sales Workspace
            </h1>
            <p className="mt-2 max-w-2xl text-sm text-[#7D8998]">
              Manage draft sales, quotations, and invoices from one cleaner
              workspace with consistent actions and faster navigation.
            </p>
          </div>

          <Tabs value={tabValue} defaultValue="draft" className="w-full xl:w-auto">
            <TabsList className="grid h-auto w-full grid-cols-3 rounded-[18px] border border-[#E4ECFA] bg-[#F5F8FD] p-1 xl:min-w-[560px]">
              <TabsTrigger
                value="draft"
                className="flex items-center gap-2 rounded-[14px] px-4 py-3 text-sm font-medium text-[#62738E] data-[state=active]:bg-[#1A5EF9] data-[state=active]:text-white"
                onClick={() => navigate("/sales/draft")}
              >
                <FileSpreadsheet className="size-4" />
                Draft
              </TabsTrigger>
              <TabsTrigger
                value="quotation"
                className="flex items-center gap-2 rounded-[14px] px-4 py-3 text-sm font-medium text-[#62738E] data-[state=active]:bg-[#1A5EF9] data-[state=active]:text-white"
                onClick={() => navigate("/sales/quatation")}
              >
                <ScrollText className="size-4" />
                Quotation
              </TabsTrigger>
              <TabsTrigger
                value="invoice"
                className="flex items-center gap-2 rounded-[14px] px-4 py-3 text-sm font-medium text-[#62738E] data-[state=active]:bg-[#1A5EF9] data-[state=active]:text-white"
                onClick={() => navigate("/sales/invoice")}
              >
                <ReceiptText className="size-4" />
                Invoice
              </TabsTrigger>
            </TabsList>
          </Tabs>
        </div>
      </section>

      <div>{children ?? <Outlet />}</div>
    </div>
  );
}

export default Sales;
